import { get, split } from 'lodash';

import { BACKGROUND_TYPES } from 'constants/landingPage';
import Model from 'models';
import CardCarouselModel from 'models/CardCarousel';

const PageSectionAssetDecoratedCarouselModel = class extends Model {
  get landscapeAsset() {
    return get(this._data, 'landscapeAsset');
  }

  get portraitAsset() {
    return get(this._data, 'portraitAsset');
  }

  get carousel() {
    return new CardCarouselModel(get(this._data, 'carousel'));
  }

  get landscapeBackgroundType() {
    const landscapeContentType = get(this.landscapeAsset, ['file', 'contentType']);
    const assetType = get(split(landscapeContentType, '/'), 0);

    let backgroundType = '';
    if (assetType === 'image') {
      backgroundType = BACKGROUND_TYPES.IMAGE;
    } else if (assetType === 'video') {
      backgroundType = BACKGROUND_TYPES.VIDEO;
    }

    return backgroundType;
  }

  get portraitBackgroundType() {
    const mobileContentType = get(this.portraitAsset, ['file', 'contentType']);
    const assetType = get(split(mobileContentType, '/'), 0);

    let backgroundType = '';
    if (assetType === 'image') {
      backgroundType = BACKGROUND_TYPES.IMAGE;
    } else if (assetType === 'video') {
      backgroundType = BACKGROUND_TYPES.VIDEO;
    }

    return backgroundType;
  }
};

export default PageSectionAssetDecoratedCarouselModel;
